import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import jwt_decode from 'jwt-decode';
import { hasIn } from 'lodash';

import { permissions } from '../store/account/account.selectors';
import { JwtService } from './jwt.service';
import { AccountState } from '../store/account/account.reducer';
import { Rule } from '../proto/consulate/accounts/interfaces/rule.interface';
import { setOXIOAdmin } from '../store/account/account.actions';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  userPermissions: Rule[];

  constructor(
    private jwtService: JwtService,
    private store: Store<AccountState>
  ) {
    this.getUserPermissions();
  }

  /**
   * Get user permissions
   */
  getUserPermissions() {
    this.store
      .pipe(select(permissions))
      .subscribe((userPermissions: Rule[]) => {
        this.userPermissions = userPermissions;
      });
  }

  /**
   * Check if admin account
   */
  private _isOxioAdmin(): boolean {
    const jwtToken = this.jwtService.getToken();
    if (typeof jwtToken !== 'undefined') {
      const decodedData = jwt_decode(jwtToken);

      if (hasIn(decodedData, 'oau')) {
        return true;
      }
    }
    return false;
  }

  /**
   * Dispatch isOxioAdmin value in account store
   */
  setIsOxioAdmin() {
    const isOxioAdmin = this._isOxioAdmin();
    this.store.dispatch(setOXIOAdmin({ isOxioAdmin }));
  }

  validateResource(accessRule: Rule): boolean {
    const resArr = accessRule.res.split('.');
    for (let userRule of this.userPermissions) {
      const checkedRes = this.checkRes(resArr, userRule);

      if (typeof checkedRes !== 'undefined' && checkedRes) {
        return checkedRes;
      }
    }

    return false;
  }

  checkRes(resArr: string[], userRule: Rule): boolean {
    const userRuleArr = userRule.res.split('.');

    for (var i = 0; i < resArr.length; i++) {
      if (userRuleArr[i] === '*') {
        return true;
      } else if (resArr[i] !== userRuleArr[i] || userRule.mode === '-r') {
        return false;
      } else if (resArr[i] === userRuleArr[i] && resArr.length === i + 1) {
        return true;
      }
    }
  }

  /**
   * Grant or deny access to the resource
   * @param accessRule
   */
  grantAccess(accessRule: Rule): boolean {
    if (typeof this.userPermissions !== 'undefined') {
      if (this._isOxioAdmin()) {
        return true;
      }

      if (!hasIn(accessRule, 'mode')) {
        console.error(`Rule for \"${accessRule.res}\" must have a mode.`);

        return false;
      }

      if (typeof accessRule.mode === 'undefined') {
        console.error(`Rule mode for \"${accessRule.res}\" is invalid.`);

        return false;
      }

      return this.validateResource(accessRule);
    }

    return false;
  }
}
